import { apiClient } from '@/shared/api/http-client';

export const recordingApi = {
    start: async (sessionId: string, signal?: AbortSignal) => {
        await apiClient.post(
            '/recordings/start',
            { target: 'session', targetId: sessionId },
            signal,
        );
    },
};
